import { render, staticRenderFns } from "./GenerateOptionsButton.vue?vue&type=template&id=10f1e3a7&scoped=true&"
import script from "./GenerateOptionsButton.vue?vue&type=script&lang=js&"
export * from "./GenerateOptionsButton.vue?vue&type=script&lang=js&"
import style0 from "./GenerateOptionsButton.vue?vue&type=style&index=0&id=10f1e3a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f1e3a7",
  null
  
)

export default component.exports